__turbopack_context__.v({
  "wrapper": "AddToCartButton-module__FNqH5a__wrapper",
});
